const t1Items = document.querySelectorAll('li[data-mega-tab]');
const t2Items = document
  .querySelector('.mega-menu-lower')
  .querySelectorAll('[data-mega-tab]');

// Show relevant lower menu on hover
t1Items.forEach(t1 => {
  const t1Idx = t1.getAttribute('data-mega-tab');
  t1.addEventListener('mouseover', e => {
    t1Items.forEach(t1i => t1i.classList.remove('mega-t1-active'));
    t2Items.forEach(t2 => {
      t2.classList.remove('t2-fade-in');
      const t2Idx = t2.getAttribute('data-mega-tab');
      if (t2Idx == t1Idx) {
        t1.classList.add('mega-t1-active');
        t2.classList.add('t2-fade-in');
      }
    });
  });
});

// remove on leave t1 wrapper or lower box
/*
const header = document.querySelector('#header');
header.addEventListener('mouseleave', (e) => {
  t2Items.forEach((t2) => {
    t2.classList.remove('t2-fade-in');
  });
});
*/
const lowerMega = document.querySelector('.mega-menu-lower');

lowerMega.addEventListener('mouseleave', e => {
  t2Items.forEach(t2 => {
    t2.classList.remove('t2-fade-in');
  });
  t1Items.forEach(t1i => t1i.classList.remove('mega-t1-active'));
});

lowerMega.classList.remove('hide');
